import { carregarGrupoDeLocaisDeTrabalhoDaStore } from '@/integracoes/src-next/catalogos/catalogos-governanca.vuex'
import { freezeItems } from './freezeItems'

const PER_PAGE = 30

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false,
    pronto: false,
    atualizando: false,
    erro: null,
    sincronizadoEm: null
  },
  getters: {
    todosGrupos (state) {
      return state.items || []
    }
  },
  mutations: {
    saveItems (state, payload) {
      state.items = freezeItems(payload)
      state.loading = false
    },
    resetItems (state) {
      state.items = []
      state.pronto = false
      state.loading = false
      state.atualizando = false
      state.erro = null
      state.sincronizadoEm = null
    },
    publicarCatalogo (state, { items, ...estado }) {
      if (items !== undefined) state.items = freezeItems(items)
      Object.assign(state, estado)
    },
    loading (state, payload) {
      state.loading = Boolean(payload)
    }
  },
  actions: {
    async fetchItems ({ state, dispatch }, payload = {}) {
      if (payload.page !== undefined || payload.search || payload.id || (payload.withFields || []).some(campo => !['id', 'name', 'companies', 'groups'].includes(campo))) return dispatch('consultarItensEspecificos', payload)
      await carregarGrupoDeLocaisDeTrabalhoDaStore(this, payload.fullReload === true)
      return state.items
    },
    async consultarItensEspecificos (contexto, payload = {}) {
      const { API, retryRequest } = await import('src/services')
      const result = await retryRequest(API.userGroup.get, { order_by: 'name', ...payload })
      return result.status === 204 ? { success: [], total: 0, totalPages: 0 } : result.body
    },
    async fetchItemsComPaginacao ({ dispatch }, payload = {}) {
      return dispatch('consultarItensEspecificos', { ...payload, page: payload.page || 0, per_page: PER_PAGE })
    }
  }
}
